import LearnPageLayout from "@/components/LearnPageLayout";
import { page1 } from "./learnDataP1";

/**
 * Static route wrapper for /learn/what-is-saint-tms.
 * Using an explicit static route (not a /learn/:slug param) ensures the
 * platform's static generator prerenders the full article HTML so crawlers
 * and AI search systems can read the educational content.
 */
const WhatIsSaintTmsPage = () => (
  <LearnPageLayout
    title={page1.title}
    description={page1.description}
    canonical={page1.canonical}
    h1={page1.h1}
    breadcrumbLabel={page1.breadcrumbLabel}
    crumbs={page1.crumbs}
    shortAnswer={page1.shortAnswer}
    keyTakeaways={page1.keyTakeaways}
    sections={page1.sections}
    faqs={page1.faqs}
    sources={page1.sources}
    schemaJson={page1.schemaJson}
    relatedLinks={page1.relatedLinks}
  />
);

export default WhatIsSaintTmsPage;
